module.exports = __webpack_public_path__ + "d664201f/img/lock-icon.bb9c7166.svg";